import drivewealthResource from "@/shared/resource/drivewealth";
import {
  DrivewealthAccount,
  DrivewealthAccountSummary,
  DrivewealthCreateCustomerRequest,
  DrivewealthDocumentListPage,
  AdvisoryFund,
  ActivityHistoryElement,
  DrivewealthOrderRequest,
  InstrumentDetail,
  DelayedQuote,
  PendingActivity,
  AllowedInvestmentAccountTypes,
  AllowedEmployerInvestmentAccountTypes,
  DrivewealthSweep,
  DrivewealthSweepStatus,
  DrivewealthSweepStatusPartnerManagement,
  DrivewealthUpdateAccountRequest,
  DrivewealthUpdateAccountRequestV2,
  FlatManagedPortfolioResponse,
  RiskToleranceQuestionnaire,
  RiskToleranceQuestionnaireForm,
  RiskToleranceQuestionnaireResponse,
  InstrumentSearchResponse,
  DrivewealthEnrollmentDto,
  DrivewealthManagedDepositRequest,
  ManagedTransfersActivityHistoryElement,
  DrivewealthManagedRedemptionRequest,
  DayTradeSummaryResponse,
  DrivewealthEnrollment,
  DrivewealthAccountManagementType,
  AccountMigrationPeriodStatusResponse,
  DrivewealthAccountClaim,
  DrivewealthDripDisclosures,
  UserRtqEligibilityResponse,
  DrivewealthAccountCancelUploadListPage,
  InvestmentBalancesResponse,
  InvestmentCustodian,
  DropDownModel,
  InstrumentSearchRequest,
  InvestmentThreshold,
  DrivewealthServicerOrderRequest,
  DrivewealthServicerManagedRedemptionRequest,
  BulkLiquidationUploadListPage,
  DrivewealthAccountPerformance,
  AccountCloseReasonResponse,
  AccountCloseReasonModel,
  DrivewealthAccountPerformanceTimePeriod,
  DrivewealthClosedAccountSummary,
  InstrumentPerformanceGraphTimePeriod,
  GenericGraphPoint,
  DrivewealthAccountRateOfReturnModel
} from "@/shared/types";
import {
  RiskQuizAgeRevision,
  RiskQuizAgePortfolio,
  InstrumentList,
  InstrumentUploadResponse,
  InstrumentMetadataResponse,
  PartnerEmployerInstrumentList,
  DemoRosterResponse,
  DemoRosterSaveRequest,
  DemoRosterSaveResponse,
  EmployerDrivewealthListRequest,
  CustodianDrivewealthListRequest,
  EmployerMigrationPeriod,
  PartnerAccountsMigrationModel,
  ListType,
  CustodianDefaultAgreementModel,
  UpdateCustodianDefaultAgreementRequest,
  EmployerAgreementModel,
  UpdateEmployerAgreementRequest,
  InvestmentAccountDetails
} from "@/admin/types";
import { authorizedAxios } from "./authorizedAxios";

export function getAdvisoryFunds (username: string, partnerId: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<AdvisoryFund[]>(drivewealthResource.funds, data);
}
export function getCuratedRtqFunds (username: string, partnerId: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<AdvisoryFund[]>(drivewealthResource.curatedRtqFunds, data);
}

export function getCustomerAccounts (username: string, partnerId: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<DrivewealthAccount[]>(drivewealthResource.accounts, data);
}
export function getDocumentUrl (id: number, username: string, partnerId: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<string>( drivewealthResource.getDocumentUrl(id), data);
}
export function createCustomerAccount (request: DrivewealthCreateCustomerRequest) {
  return authorizedAxios.post<DrivewealthAccount>(drivewealthResource.accounts, request);
}
export function getDrivewealthAccountClaims (username: string, partnerId: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<DrivewealthAccountClaim[]>(drivewealthResource.accountClaims, data);
}
export function claimAccount (accountId: number, request: DrivewealthCreateCustomerRequest) {
  return authorizedAxios.post<DrivewealthAccountClaim>(drivewealthResource.claimAccount(accountId), request);
}
export function liquidateAccount (accountId: number, partnerId: number) {
  return authorizedAxios.post<string>(partnerId ? drivewealthResource.partnerLiquidateAccount(accountId, partnerId) : drivewealthResource.liquidateAccount(accountId));
}

export function updateAccountV2 (accountId: number, request: DrivewealthUpdateAccountRequestV2) {
  return authorizedAxios.post<DrivewealthAccount>(drivewealthResource.updateAccountV2(accountId), request);
}
export function closeAccount (accountId: number, reason: AccountCloseReasonModel) {
  return authorizedAxios.post<DrivewealthAccount>(drivewealthResource.closeAccount(accountId), reason);
}
export function getAccountCloseReasons () {
  return authorizedAxios.get<AccountCloseReasonResponse[]>(drivewealthResource.accountCloseReasons);
}

export function getPendingActivityByAccount (username: string, partnerId: number, accountId: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<PendingActivity>(drivewealthResource.pendingActivityByAccount(accountId), data);
}

export function getCompletedActivityByAccount (page: number, pageSize: number,
  username: string, partnerId: number, accountId: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<ActivityHistoryElement[]>(
      drivewealthResource.getCompletedActivityByAccount(page, pageSize, accountId), data);
}

export function getManagedTransfersActivityByAccount (page: number, pageSize: number,
  username: string, partnerId: number, accountId: number) {
  const data: any = (username) ? { forUser: username, forUserPartnerId: partnerId } : {};
  data.page = page;
  data.pageSize = pageSize;
  return authorizedAxios.get<ManagedTransfersActivityHistoryElement[]>(
      drivewealthResource.getManagedTransfersActivityByAccount(accountId), data);
}

export function postCancelOrderRequest (bendOrderId: string) {
  return authorizedAxios.post<void>(drivewealthResource.postCancelOrderRequest(bendOrderId));
}
export function postOrderRequestByAccount (orderRequest: DrivewealthOrderRequest, accountId: number) {
  return authorizedAxios.post<void>(drivewealthResource.postOrderRequestByAccount(accountId), orderRequest);
}
export function servicerPostOrderRequestByAccount (partnerId: number, orderRequest: DrivewealthServicerOrderRequest, accountId: number) {
  return authorizedAxios.post<void>(drivewealthResource.servicerPostOrderRequestByAccount(accountId, partnerId), orderRequest);
}

export function postManagedDepositByAccount (depositRequest: DrivewealthManagedDepositRequest, accountId: number) {
  return authorizedAxios.post<void>(drivewealthResource.postManagedDepositByAccount(accountId), depositRequest);
}
export function postManagedRedemptionByAccount (redemptionRequest: DrivewealthManagedRedemptionRequest, accountId: number) {
  return authorizedAxios.post<void>(drivewealthResource.postManagedRedemptionByAccount(accountId), redemptionRequest);
}
export function servicerPostManagedRedemptionByAccount (partnerId: number, redemptionRequest: DrivewealthServicerManagedRedemptionRequest, accountId: number) {
  return authorizedAxios.post<void>(drivewealthResource.servicerPostManagedRedemptionByAccount(accountId, partnerId), redemptionRequest);
}
export function getDayTrades (username: string, partnerId: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<DayTradeSummaryResponse>(drivewealthResource.dayTrades, data);
}
export function getInstrument (username: string, partnerId: number, stockSymbol: string) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<InstrumentDetail>(drivewealthResource.getInstrument(stockSymbol), data);
}
export function getInstrumentByAccountId (username: string, partnerId: number,
  { stockSymbol, accountId }: { stockSymbol: string, accountId: number }) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<InstrumentDetail>(drivewealthResource.getInstrumentByAccountId(stockSymbol, accountId), data);
}
export function getInstrumentFundResearchUrl (stockSymbol: string) {
  return authorizedAxios.get<string>(drivewealthResource.getInstrumentFundResearchUrl(stockSymbol));
}

export function searchInstrumentsByAccountId (search: string, accountId: number, pageNumber: number, pageSize: number, availableToBuyOnly: boolean) {
  return authorizedAxios.get<InstrumentSearchResponse>(drivewealthResource.searchInstrumentsByAccountId(accountId, pageNumber, pageSize, availableToBuyOnly), {search});
}
export function searchInstrumentsWithFundType (request: InstrumentSearchRequest) {
  return authorizedAxios.post<InstrumentSearchResponse>(drivewealthResource.searchInstrumentsWithFundType(), request);
}
export function getAssetClasses () {
  return authorizedAxios.get<DropDownModel[]>(drivewealthResource.getAssetClasses());
}
export function getFundCompanies () {
  return authorizedAxios.get<DropDownModel[]>(drivewealthResource.getFundCompanies());
}
export function getRiskQuizAgeRevisions () {
  return authorizedAxios.get<RiskQuizAgeRevision>(drivewealthResource.riskQuizAgeRevision);
}
export function getRiskQuizAgePortfolios () {
  return authorizedAxios.get<RiskQuizAgePortfolio>(drivewealthResource.riskQuizAgePortfolios);
}
export function processRiskQuizAgeRevisionFile (csv: any ) {
  return authorizedAxios.postFiles(drivewealthResource.riskQuizAgeRevision, [csv]);
}
export function processRiskQuizAgePortfolioFile (csv: any ) {
  return authorizedAxios.postFiles(drivewealthResource.riskQuizAgePortfolios, [csv]);
}
export function getInstrumentLists (listType: ListType) {
  return authorizedAxios.get<InstrumentList[]>(drivewealthResource.instrumentLists(`${listType}`));
}
export function getCuratedRtqInstrumentList (username: string, partnerId: number, instrumentListId: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<InstrumentDetail[]>(drivewealthResource.instrumentList(instrumentListId), data);
}
export function getInstrumentList (instrumentListId: number) {
  return authorizedAxios.get<InstrumentDetail[]>(drivewealthResource.instrumentList(instrumentListId));
}
export function getInstrumentListCsv (instrumentListId: number) {
  return authorizedAxios.get(drivewealthResource.instrumentListCsv(instrumentListId));
}
export function getWlpInstrumentList (custodian: number, investmentOption: DrivewealthAccountManagementType) {
  return authorizedAxios.get<InstrumentList[]>(drivewealthResource.wlpInstrumentList(custodian, investmentOption));
}
export function getEmployerDefaultInstrumentLists (employerId: number) {
  return authorizedAxios.get<InstrumentList[]>(drivewealthResource.employerDefaultInstrumentLists(employerId));
}
export function saveEmployerDefaultList (request: EmployerDrivewealthListRequest) {
  return authorizedAxios.post<boolean>(drivewealthResource.saveEmployerDefaultList, request);
}
export function saveCustodianDefaultList (request: CustodianDrivewealthListRequest) {
  return authorizedAxios.post<boolean>(drivewealthResource.saveCustodianDefaultList, request);
}
export function getCustodianDefaultInstrumentLists (custodian: number) {
  return authorizedAxios.get<InstrumentList[]>(drivewealthResource.custodianDefaultInstrumentLists(custodian));
}
export function createInstrumentList (instrumentList: InstrumentList) {
  return authorizedAxios.post<InstrumentList[]>(drivewealthResource.createInstrumentList, instrumentList);
}
export function processInstrumentListFile (instrumentListId: number, csv: any ) {
  return authorizedAxios.postFiles<InstrumentUploadResponse>(drivewealthResource.instrumentList(instrumentListId), [csv]);
}
export function processInstrumentMetadataFile ( csv: any ) {
  return authorizedAxios.postFiles<InstrumentMetadataResponse>(drivewealthResource.instrumentMetadata, [csv]);
}

export function getPartnerInstrumentLists (partnerId: number) {
  return authorizedAxios.get<PartnerEmployerInstrumentList>(drivewealthResource.partnerInvestmentList(partnerId));
}
export function setPartnerInstrumentLists (partnerId: number, advisoryListId: number, openBrokerageListId: number) {
  return authorizedAxios.put<PartnerEmployerInstrumentList>(
    drivewealthResource.partnerInvestmentList(partnerId), { advisoryListId, openBrokerageListId });
}
export function getPartnerInvestmentTypes (partnerId: number) {
  return authorizedAxios.get<AllowedInvestmentAccountTypes>(drivewealthResource.partnerInvestmentType(partnerId));
}
export function setPartnerInvestmentTypes (partnerId: number, investmentType: AllowedInvestmentAccountTypes) {
  return authorizedAxios.post<void>(drivewealthResource.partnerInvestmentType(partnerId), investmentType);
}
export function getEmployerInvestmentTypes (employerId: number) {
  return authorizedAxios.get<AllowedEmployerInvestmentAccountTypes>(drivewealthResource.employerInvestmentType(employerId));
}
export function setEmployerInvestmentTypes (employerId: number, investmentType: AllowedInvestmentAccountTypes) {
  return authorizedAxios.post<void>(drivewealthResource.employerInvestmentType(employerId), investmentType);
}
export function getEmployeeInvestmentTypes (username?: string, partnerId?: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<AllowedInvestmentAccountTypes>(drivewealthResource.employeeInvestmentType, data);
}
export function getRiskToleranceQuestionnaire (username: string, partnerId: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<RiskToleranceQuestionnaire>(drivewealthResource.riskToleranceQuestionnaire, data);
}
export function putRiskToleranceQuestionnaire (riskToleranceQuestionnaire: RiskToleranceQuestionnaire) {
  return authorizedAxios.put<FlatManagedPortfolioResponse>(drivewealthResource.riskToleranceQuestionnaire,
    riskToleranceQuestionnaire);
}
export function getManagedPortfolio (username: string, partnerId: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<FlatManagedPortfolioResponse>(drivewealthResource.getManagedPortfolio, data);
}
export function postRiskToleranceQuestionnaire (riskToleranceQuestionnaire: RiskToleranceQuestionnaire) {
  return authorizedAxios.post<void>(drivewealthResource.evaluateRiskToleranceQuestionnaire,
    riskToleranceQuestionnaire);
}
export function getSweep (username: string, partnerId: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<DrivewealthSweep>(drivewealthResource.sweep, data);
}

export function postSweepV2 (drivewealthSweep: DrivewealthSweep) {
  return authorizedAxios.post<DrivewealthSweep>(drivewealthResource.sweepV2, drivewealthSweep);
}

export function sweepAddInstrument (accountId: number, stockSymbol: string) {
  return authorizedAxios.post<DrivewealthSweep>(drivewealthResource.sweepAddInstrument(accountId, stockSymbol));
}

export function postSweepStatus (sweepStatus: DrivewealthSweepStatus) {
  return authorizedAxios.post<DrivewealthSweepStatus>(drivewealthResource.sweepStatus, { sweepStatus });
}

export function postSweepStatusPartnerManagement (sweepStatus: DrivewealthSweepStatusPartnerManagement) {
  return authorizedAxios.post<DrivewealthSweepStatus>(drivewealthResource.sweepStatusPartnerManagement, sweepStatus);
}

export function getEnrollmentStatus (username: string, partnerId: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<DrivewealthEnrollmentDto>(drivewealthResource.enrollment, data);
}
export function postPreenrollment (enrollment: DrivewealthEnrollmentDto) {
  return authorizedAxios.post<DrivewealthEnrollmentDto>(drivewealthResource.enrollment, enrollment);
}
export function deletePreenrollment () {
  return authorizedAxios.delete<void>(drivewealthResource.enrollment);
}
export function postEnrollNow () {
  return authorizedAxios.post<DrivewealthAccount>(drivewealthResource.enrollNow);
}
export function getDemoMockRosters () {
  return authorizedAxios.get<DemoRosterResponse>(drivewealthResource.demoMockGetRosters);
}
export function getDemoMockAreRostersOutOfDate () {
  return authorizedAxios.get<boolean>(drivewealthResource.demoMockGetAreRostersOutOfDate);
}
export function putDemoMockOpenBrokerageRoster (request: DemoRosterSaveRequest) {
  return authorizedAxios.put<DemoRosterSaveResponse>(drivewealthResource.demoMockOpenBrokerageRoster, request);
}
export function putDemoMockRiaManagedRoster (request: DemoRosterSaveRequest) {
  return authorizedAxios.put<DemoRosterSaveResponse>(drivewealthResource.demoMockRiaManagedRoster, request);
}
export function putDemoMockClearRosters () {
  return authorizedAxios.put<void>(drivewealthResource.demoMockClearAllRosters);
}

export function getAccountIdsV2 () {
  return authorizedAxios.get<number[]>(drivewealthResource.accountIdsV2());
}

export function getDocumentsV2 (
  username: string, partnerId: number,
  args: { dwAccountId: number, page: number, pageSize: number }
  ) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<DrivewealthDocumentListPage>(
    drivewealthResource.getDocumentsV2(args.page, args.pageSize, args.dwAccountId), data);
}

export function getAccountSummaryV2 (username: string, partnerId: number, dwAccountId: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<DrivewealthAccountSummary>(drivewealthResource.accountSummaryV2(dwAccountId), data);
}

export function getAccountSummariesV2 (username: string, partnerId: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<DrivewealthAccountSummary[]>(drivewealthResource.accountSummariesV2, data);
}

export function getClosedAccountSummaries (username: string, partnerId: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<DrivewealthClosedAccountSummary[]>(drivewealthResource.closedAccountSummaries, data);
}

export function getEmployerMigrationPeriod (employerId: number) {
  return authorizedAxios.get<EmployerMigrationPeriod>(drivewealthResource.employerMigrationPeriod(employerId));
}
export function saveEmployerMigrationPeriod (employerId: number, request: EmployerMigrationPeriod) {
  return authorizedAxios.post<EmployerMigrationPeriod>(
    drivewealthResource.employerMigrationPeriod(employerId), request);
}

export function getPartnerAccountsMigration (partnerId: number) {
  return authorizedAxios.get<PartnerAccountsMigrationModel>(drivewealthResource.getPartnerAccountsMigration(partnerId));
}

export function updatePartnerAccountsMigration (partnerId: number, request: PartnerAccountsMigrationModel) {
  return authorizedAxios
  .post<PartnerAccountsMigrationModel>(drivewealthResource.updatePartnerAccountsMigration(partnerId), request);
}

export function createPartnerAccountsMigration (partnerId: number, request: PartnerAccountsMigrationModel) {
  return authorizedAxios
  .post<PartnerAccountsMigrationModel>(drivewealthResource.createPartnerAccountsMigration(partnerId), request);
}

export function getAccountMigrationPeriodStatus () {
  return authorizedAxios.get<AccountMigrationPeriodStatusResponse>(
    drivewealthResource.getAccountMigrationPeriodStatus());
}

export function getRiskToleranceQuestionnaireResults () {
  return authorizedAxios.get<RiskToleranceQuestionnaireResponse>(drivewealthResource.riskToleranceQuetionnaire());
}

export function getUserRtqEligibilityResponse () {
  return authorizedAxios.get<UserRtqEligibilityResponse>(drivewealthResource.userRtqEligibility());
}

export function saveRiskToleranceQuestionnaire (request: RiskToleranceQuestionnaireForm, saveToDb: boolean) {
  return authorizedAxios.post<RiskToleranceQuestionnaireResponse>(
    drivewealthResource.postRiskToleranceQuetionnaire(saveToDb), request);
}

export function evaluateManagedRtqAnswers (request: RiskToleranceQuestionnaireForm) {
    return authorizedAxios.post<FlatManagedPortfolioResponse>(
        drivewealthResource.evaluateManagedRtqAnswers(), request);
}

export function getDividendReinvestmentDisclosures (username: string, partnerId: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<DrivewealthDripDisclosures>(drivewealthResource.dividendReinvestmentDisclosure(), data);
}

export function getCustodianDefaultAgreement (custodian: number) {
  return authorizedAxios.get<CustodianDefaultAgreementModel>(drivewealthResource.getCustodianDefaultAgreement(custodian));
}

export function saveCustodianDefaultAgreement (request: UpdateCustodianDefaultAgreementRequest) {
  return authorizedAxios.post<UpdateCustodianDefaultAgreementRequest>(drivewealthResource.saveCustodianDefaultAgreement(), request);
}

export function getEmployerAgreement (employerId: number) {
  return authorizedAxios.get<EmployerAgreementModel>(drivewealthResource.getEmployerAgreement(employerId));
}

export function saveEmployerAgreement (request: UpdateEmployerAgreementRequest) {
  return authorizedAxios.post<UpdateEmployerAgreementRequest>(drivewealthResource.saveEmployerAgreement(), request);
}

export function getUserAgreementDocumentKey (accountType: string) {
  return authorizedAxios.get<string>(drivewealthResource.getUserAgreementDocumentKey(accountType));
}

export function getUserInvestmentAccountsByUsername (username: string) {
  return authorizedAxios.get<InvestmentAccountDetails[]>(drivewealthResource.investmentAccountSearch(username));
}

export function uploadAccountCloseFile (file: any ) {
  return authorizedAxios.postFiles(drivewealthResource.uploadAccountCloseFile, [file]);
}

export function uploadBulkLiquidateFile (partnerId: number, file: any ) {
  return authorizedAxios.postFiles(drivewealthResource.uploadBulkLiquidateFile(partnerId), [file]);
}

export function getAccountCloseFileRequests (
  username: string, partnerId: number,
  args: { dwAccountId: number, page: number, pageSize: number }
  ) {
  return authorizedAxios.get<DrivewealthAccountCancelUploadListPage>(
    drivewealthResource.accountCloseFileRequests(args.page, args.pageSize));
}

export function getBulkLiquidationFileRequests (
    username: string, partnerId: number,
    args: { dwAccountId: number, page: number, pageSize: number }
) {
  return authorizedAxios.get<BulkLiquidationUploadListPage>(
      drivewealthResource.bulkLiquidationFileRequests(partnerId, args.page, args.pageSize));
}

export function downloadResultsFileCsv (drivewealthAccountCancelUploadId: number ) {
  return authorizedAxios.get(drivewealthResource.downloadResultsFileCsv(drivewealthAccountCancelUploadId));
}

export function downloadBulkLiquidationStatus (partnerId: number, fileNameGuid: string ) {
    return authorizedAxios.get(drivewealthResource.bulkLiquidationStatus(partnerId, fileNameGuid));
}

export function getAccountPerformanceData (
    username: string, partnerId: number,
    args: { accountId: number, timePeriod: DrivewealthAccountPerformanceTimePeriod }
) {
  const data = (username) ? {forUser: username, forUserPartnerId: partnerId} : undefined;
  return authorizedAxios.get<DrivewealthAccountPerformance>(
      drivewealthResource.getAccountPerformanceData(args.accountId, args.timePeriod),
      data);
}

export function getAccountPerformanceRateOfReturn (
    username: string, partnerId: number,
    args: { accountId: number }
) {
  const data = (username) ? {forUser: username, forUserPartnerId: partnerId} : undefined;
  return authorizedAxios.get<DrivewealthAccountRateOfReturnModel>(
      drivewealthResource.getAccountPerformanceRateOfReturn(args.accountId), data);
}
export function getInstrumentPerformanceData (
    username: string, partnerId: number,
    args: { stockSymbol: string },
) {
  const data = (username) ? {forUser: username, forUserPartnerId: partnerId} : undefined;
  return authorizedAxios.get<any>(
      drivewealthResource.getInstrumentPerformanceData(args.stockSymbol),
      data);
}

export function getInstrumentPerformanceGraphData (
    username: string, partnerId: number,
    args: { stockSymbol: string, timePeriod: InstrumentPerformanceGraphTimePeriod },
) {
  const data = (username) ? {forUser: username, forUserPartnerId: partnerId} : undefined;
  return authorizedAxios.get<GenericGraphPoint[]>(
      drivewealthResource.getInstrumentPerformanceGraphData(args.stockSymbol, args.timePeriod),
      data);
}

export function getBalanceThresholds (username: string, partnerId: number) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<InvestmentThreshold>(drivewealthResource.getBalanceThresholds(), data);
}

export function getInvestmentDailyBalances (
  username: string,
  partnerId: number,
  accountId: number,
  args: { startDate: string, endDate: string, investmentCustodian?: InvestmentCustodian }
) {
  const data = (username) ? { forUser: username, forUserPartnerId: partnerId } : undefined;
  return authorizedAxios.get<InvestmentBalancesResponse>(
    drivewealthResource.getInvestmentDailyBalances(
      args.startDate,
      args.endDate,
      accountId
    ),
    data
  );
}